import { CloseOctagonIcon } from './CloseOctagonIcon';

/**
 * author: Simran
 * id BA7E9F56-A5F5-4BEE-8934-90CA070A6029
 * name close-octagon
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/close-octagon.svg
 * tags
 */
export const CancelOctagonIcon = CloseOctagonIcon;
export default CancelOctagonIcon